module.exports = __webpack_public_path__ + "static/media/usa.f4fb51af.png";